module.exports = __webpack_public_path__ + "static/media/nisse-hit.aa428fe8.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/nisse-hit.png
// module id = 41
// module chunks = 0